import React from "react";
import ContactUsForm from "./ContactUsForm";
import { DS } from "../../utils/designSystem";

const ContactForm = () => {
  return (
    <div className={`${DS.card.base} ${DS.card.pad}`}>
      <h2 className="text-2xl font-bold text-richblack-5 mb-1">
        Send Us a Message
      </h2>
      <p className={`${DS.text.caption} mb-8`}>
        Have a question about enrolling, course content, or partnerships? Fill
        in the form below and we&apos;ll get back to you shortly.
      </p>
      <ContactUsForm />
    </div>
  );
};

export default ContactForm;
